/* sundaze refresh: size guide shortcut next to the size picker */
(function () {
  function guide() { return document.getElementById('size-guide'); }
  function openGuide(scroll) {
    var d = guide();
    if (!d) return;
    d.open = true;
    if (scroll) d.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function addLink() {
    if (!guide()) return;
    document.querySelectorAll('variant-picker').forEach(function (vp) {
      var next = vp.nextElementSibling;
      if (next && next.classList.contains('sdz-size-row')) return;
      var row = document.createElement('p');
      row.className = 'sdz-size-row';
      row.innerHTML = '<a href="#size-guide" class="sdz-size-link">size guide</a><span class="sdz-size-hint">all sales are final, so check measurements first.</span>';
      row.querySelector('a').addEventListener('click', function (e) { e.preventDefault(); openGuide(true); });
      vp.insertAdjacentElement('afterend', row);
    });
  }
  function init() {
    addLink();
    if (location.hash === '#size-guide') openGuide(true);
    new MutationObserver(function () { addLink(); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
